/**
 * 🏗️ FSD Features Layer - Activity Dashboard Hook
 * 
 * ActivityPage의 모든 비즈니스 로직을 관리하는 커스텀 훅
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useMemo } from 'react';
import { MOCK_ACTIVITIES, MOCK_SKILLS, MOCK_ACHIEVEMENTS, MOCK_STATS, MOCK_AI_FEEDBACKS, AREA_COLORS, DEFAULT_FILTERS } from '@edusense/shared-activity-constants';
import { filterActivities } from '@edusense/shared-activity-utils';
/**
 * Activity Dashboard 비즈니스 로직 훅
 */ export var useActivityDashboard = function() {
    // 필터 상태
    var _useState = _sliced_to_array(useState(DEFAULT_FILTERS), 2), filters = _useState[0], setFilters = _useState[1];
    // 피드백 시각화 타입 상태
    var _useState1 = _sliced_to_array(useState('bar'), 2), feedbackVisualType = _useState1[0], setFeedbackVisualType = _useState1[1];
    // 필터 변경 핸들러
    var handleFilterChange = function(key, value) {
        setFilters(function(prev) {
            return _object_spread_props(_object_spread({}, prev), _define_property({}, key, value));
        });
    };
    // 필터링된 활동 목록 (메모이제이션)
    var filteredActivities = useMemo(function() {
        return filterActivities(MOCK_ACTIVITIES, filters);
    }, [
        filters
    ]);
    // 피드백 시각화 타입 토글
    var toggleFeedbackVisualType = function() {
        setFeedbackVisualType(function(prev) {
            return prev === 'bar' ? 'table' : 'bar';
        });
    };
    return {
        // 상태
        filters: filters,
        feedbackVisualType: feedbackVisualType,
        // 데이터
        activities: MOCK_ACTIVITIES,
        filteredActivities: filteredActivities,
        skills: MOCK_SKILLS,
        achievements: MOCK_ACHIEVEMENTS,
        stats: MOCK_STATS,
        aiFeedbacks: MOCK_AI_FEEDBACKS,
        areaColors: AREA_COLORS,
        // 액션
        handleFilterChange: handleFilterChange,
        toggleFeedbackVisualType: toggleFeedbackVisualType,
        setFeedbackVisualType: setFeedbackVisualType
    };
};
